import { axiosTemplate } from '../../axiosTemplate';
export const auth = {
    endpoints: {
        test: 'https://bb176vxozb.execute-api.us-east-1.amazonaws.com/test',
        acceptance: 'https://kdpzvo8id2.execute-api.us-east-1.amazonaws.com/acceptance',
        prod: 'https://fkjxdwk48f.execute-api.us-east-1.amazonaws.com/prod',
    },
    http: {
        graphQL: ({ data, stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).post(`${auth.endpoints[stage]}/graphql/v0`, data);
        },
    },
};
